/* ===================================================================
   CART FEEDBACK — Naaz Collection

   Problem this solves: when Shopify refuses an add-to-cart it returns
   422 with a perfectly good localised message, e.g.
     "De maximale hoeveelheid van dit artikel zit al in je winkelwagen."
   The Kalles bundle swallows that response, so the ORDER button looks
   broken — you click it and nothing at all happens, with no clue why.

   Rather than modify the theme's compiled cart JS (opaque, and it owns
   real checkout behaviour), this wraps fetch/XHR and only reacts to
   responses the theme already made. It never issues its own cart
   requests and never changes a successful outcome.
   =================================================================== */
(function () {
  'use strict';

  var TOAST_ID = 'naaz-cart-toast';
  var HIDE_AFTER = 5000;
  var hideTimer = null;

  function toastEl() {
    var el = document.getElementById(TOAST_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = TOAST_ID;
    el.className = 'naaz-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="naaz-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">' +
      '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5v.01"/></svg></span>' +
      '<span class="naaz-toast__msg"></span>' +
      '<button type="button" class="naaz-toast__close" aria-label="Sluiten">&times;</button>';
    document.body.appendChild(el);
    el.querySelector('.naaz-toast__close').addEventListener('click', hide);
    return el;
  }

  function hide() {
    var el = document.getElementById(TOAST_ID);
    if (el) el.classList.remove('is--open');
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
  }

  function show(message) {
    if (!message) return;
    var el = toastEl();
    el.querySelector('.naaz-toast__msg').textContent = message;
    // force reflow so the transition replays on repeated clicks
    void el.offsetWidth;
    el.classList.add('is--open');
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, HIDE_AFTER);
  }

  function isCartWrite(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
  }

  function messageFrom(payload) {
    if (!payload) return null;
    // Shopify uses `description` for the human-readable reason and falls
    // back to `message`; both are already localised by the storefront.
    return payload.description || payload.message || null;
  }

  // Infrastructure failures (429/503/proxy pages) return HTML, not JSON.
  // Without this the button would still look dead — the exact complaint.
  function fallback() {
    var el = document.getElementById('naaz-cart-strings');
    return (el && el.getAttribute('data-add-error')) || null;
  }

  /* ---- fetch ---- */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      if (url && typeof url === 'object' && url.url) url = url.url;
      var p = nativeFetch.apply(this, arguments);
      if (!isCartWrite(url)) return p;
      return p.then(function (res) {
        if (res && !res.ok) {
          res.clone().json().then(function (body) {
            show(messageFrom(body) || fallback());
          }).catch(function () { show(fallback()); });
        }
        return res;
      });
    };
  }

  /* ---- XMLHttpRequest (the Kalles bundle uses this in places) ---- */
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__naazCartWrite = isCartWrite(url);
    return open.apply(this, arguments);
  };
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__naazCartWrite) {
      this.addEventListener('load', function () {
        if (this.status >= 400) {
          var msg = null;
          try { msg = messageFrom(JSON.parse(this.responseText)); } catch (e) { /* non-JSON */ }
          show(msg || fallback());
        }
      });
    }
    return send.apply(this, arguments);
  };
})();
